/**
 * Brand switch for per-stage automation (persisted via pipeline stage PATCH).
 */

interface StageAutomationSwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
}

export function StageAutomationSwitch({
  checked,
  onChange,
  label,
}: StageAutomationSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-purple/40 ${
        checked ? 'bg-purple' : 'bg-light-lila'
      }`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-light shadow-sm transition-transform ${
          checked ? 'translate-x-4' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}
